import React from 'react';
import { View, StyleSheet } from 'react-native';
import { useTheme } from '@/context/ThemeContext';
import Button from '@/components/Buttons/Button';
import Text from '@/components/Typography/Text';
import Icon from '@/components/Icon';

export default function DeckEmptyState({ onAddColumn }) {
  const { colors } = useTheme();

  return (
    <View style={styles.container}>
      <View style={styles.inner}>
        <View style={styles.iconRow}>
          <View style={[styles.iconBox, { borderColor: colors.border_color_secondary }]}>
            <Icon name="message" size={20} color={colors.text_color_secondary} />
          </View>
          <View style={[styles.iconBox, { borderColor: colors.border_color_secondary }]}>
            <Icon name="message" size={20} color={colors.text_color_tertiary} />
          </View>
          <View style={[styles.iconBox, { borderColor: colors.border_color_secondary }]}>
            <Icon name="message" size={20} color={colors.text_color_tertiary} />
          </View>
        </View>
        <Text size="l" weight="semibold" color="primary" style={styles.title}>
          Room for your next idea.
        </Text>
        <Text size="n" color="secondary" style={styles.subtitle}>
          Add a conversation, model, bot, or tool to this workspace.
        </Text>
        <Button
          text="Add a chat column"
          variant="primary"
          size="medium"
          prependIcon="plus"
          onPress={onAddColumn}
          style={styles.button}
        />
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
  },
  inner: {
    alignItems: 'center',
    gap: 12,
    maxWidth: 400,
    paddingHorizontal: 20,
  },
  iconRow: {
    flexDirection: 'row',
    gap: 8,
    marginBottom: 8,
  },
  iconBox: {
    width: 48,
    height: 48,
    borderRadius: 12,
    borderWidth: 1,
    justifyContent: 'center',
    alignItems: 'center',
  },
  title: {
    textAlign: 'center',
  },
  subtitle: {
    textAlign: 'center',
    marginBottom: 8,
  },
  button: {
    marginTop: 4,
  },
});
